import React from 'react'
import { useCardAccordion } from '../Hooks/CardAccordion';
import { Language } from '../language';
import { WorkshopMenuItem } from '../Models/workshopMenu';

import './HelpPageSample.scss'

export function HelpPageSample() {
	useCardAccordion()

	return (
		<div className='card-accordion'>
			<h2 className='title is-3'>Help</h2>

			<div className='block'>
				<p>Click a topic below for more information.  If you require further assistance, please contact a <a href='https://www.ontariosoilcrop.org/association/contact-us/oscia-field-staff' target='_blank'>workshop leader.</a></p>
			</div>



			<div className='block'>
				<div id='filters-help' className='collapsed card'>

					<header className='card-header'>
						<p className='card-header-title'>
							Filtering Workshop Events
						</p>
						<button className='card-header-icon' aria-label='more options'>
							<span className='icon'>
								<i aria-hidden='true'></i>
							</span>
						</button>
					</header>

					<div className='card-content'>
						<div className='content'>
							<p>
							From the workshop's listing page, you may use filters to narrow down the list of available events.
							If you are unable to select a specific filter value, it is because there is not an event matching that option in the list.
							</p>
							<h5>Language</h5>
							<p>For the language in which the workshop is offered, you can select <b>English</b> and/or <b>French</b>, using the check boxes next to the language options.</p>
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/filters_1.png' alt='Language filter' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							<h5>Start &amp; End Date</h5>
							You can explore workshops offered in a specific date range, in order to focus on a time window in which you are hoping to attend. <br />
							Click on the boxes under <b>Start</b> and <b>End</b> to select dates from their respective calendars.
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/filters_2.png' alt='Date filters' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							<h5>Workshop Type</h5>
							Some workshops are offered in multiple formats. 
							<p>With these you will have the option to select <b>In-Person</b> or <b>Online</b>, to view workshops available in your preferred format.</p>
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/filters_3.png' alt='Event format filter' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							<h5>Municipality Tier 1 &amp; Municipality Tier 2</h5>
							In-person workshops are available across the province, so to narrow your search to workshops in your area, you can use the drop-down menus under <b>Municipality Tier 1</b> and <b>Municipality Tier 2</b>.
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/filters_4.png' alt='Location tier filters' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							<h5>TIP</h5>
							<ul>
								<li>
									As you scroll, the filter options you have selected will remain pinned at the top of your screen to allow for further adjustments.
								</li>
							</ul>
						</div>
					</div>

				</div>
			</div>



			<div className='block'>
				<div id='registration-help' className='collapsed card'>

					<header className='card-header'>
						<p className='card-header-title'>
							Registering for a Workshop
						</p>
						<button className='card-header-icon' aria-label='more options'>
							<span className='icon'>
								<i aria-hidden='true'></i>
							</span>
						</button>
					</header>

					<div className='card-content'>
						<div className='content'>
							Step 1. Click on the workshop event of interest to see more information.
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/registration_1.png' alt='Workshop event list item' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							Step 2. In the expanded view, click on the <b>Register</b> button.
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/registration_2.png' alt='Expanded workshop event register button' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							Step 3. You will be prompted to fill out the <b>Participant Details</b> form.
							This includes verifying your existing information from your profile on ontarioprograms.net,
							and adding additional information on your municipality, watershed, and commodity categories.
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/registration_3.png' alt='Registration form' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							Step 4. After your information has been updated and verified, you can click <b>Register</b>.
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/registration_4.png' alt='Registration form register button' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							You are now registered for the workshop of your choosing!
							<p>The workshop will be highlighted green, and you will see the word <b>Registered</b> and a green check mark.</p>
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/registration_5.png' alt='Workshop event registration confirmed' />
						</figure>
					</div>

				</div>
			</div>



			<div className='block'>
				<div id='unregistration-help' className='collapsed card'>

					<header className='card-header'>
						<p className='card-header-title'>
							Unregistering from a Workshop
						</p>
						<button className='card-header-icon' aria-label='more options'>
							<span className='icon'>
								<i aria-hidden='true'></i>
							</span>
						</button>
					</header>

					<div className='card-content'>
						<div className='content'>
							If for whatever reason you can no longer attend a workshop, you can easily unregister on the platform. 
							<p>
								Step 1. Click on the workshop event for which you are registered to see more information. 
							</p>
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/unregistration_1.png' alt='Registred workshop event list item' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							Step 2. In the expanded view, click on the <b>Unregister</b> button.
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/unregistration_2.png' alt='Unregister button' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							Step 3. A pop up will appear and prompt you to verify that you would like to unregister. 
							<p>Click the <b>Unregister</b> button.</p>
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/unregistration_3.png' alt='Confirming unregistration' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							If you clicked <b>Unregister</b> in error, you can click the <b>x</b> or <b>Cancel</b> buttons to remain registered.
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/unregistration_4.png' alt='Cancelling unregistration' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							Once unregistered from the workshop it will no longer be highlighted in green or have the <b>Registered</b> label and check mark.
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/unregistration_5.png' alt='Unregistered workshop event' />
						</figure>
					</div>

				</div>
			</div>



			<div className='block'>
				<div id='registering-guests-help' className='collapsed card'>

					<header className='card-header'>
						<p className='card-header-title'>
							Registering a Guest
						</p>
						<button className='card-header-icon' aria-label='more options'>
							<span className='icon'>
								<i aria-hidden='true'></i>
							</span>
						</button>
					</header>

					<div className='card-content'>
						<div className='content'>
							Step 1. From the <b>Participant Details</b> form*, click the plus (+) sign under <b>Add</b>. 
							<p>
							* See <a href='#registration-help'>Registering for a Workshop</a> for instructions on how to reach this form.
							</p>
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/registering_guests_1.png' alt='Add guest button' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							Step 2. Add the <b>First Name</b> and <b>Last Name</b> of your guest.
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/registering_guests_2.png' alt='Guest name fields' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							Step 3. Complete the rest form as you normally would and click <b>Register</b>. You and your guest are now both registered for the workshop.
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/registering_guests_3.png' alt='Register button' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							<h5>TIPS</h5>
							<ul>
								<li>
									You must add both your guest's first and last names, or you will not be able to proceed with registration.
								</li>
								<li>
									If your guest has previously attended a workshop with you, you can use the <b>Previous Guests</b> drop down menu to add them.
								</li>
								<li>
									To register with a guest for a workshop, you will need to make sure there are at least 2 seats available.
								</li>
							</ul>
						</div>
					</div>

				</div>
			</div>



			<div className='block'>
				<div id='calendar-help' className='collapsed card'>

					<header className='card-header'>
						<p className='card-header-title'>
							Accessing the Calendar View
						</p>
						<button className='card-header-icon' aria-label='more options'>
							<span className='icon'>
								<i aria-hidden='true'></i>
							</span>
						</button>
					</header>

					<div className='card-content'>
						<div className='content'>
							To see available workshops in a calendar view, click on the <b>Calendar</b> icon in the top right corner of the screen.
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/calendar_1.png' alt='Calendar view button' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							This will bring you to the calendar view of all available workshops with your selected filters.
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/calendar_2.png' alt='Calendar view' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							To return to the list view, select the <b>List</b> icon in the top right corner of the screen.
						</div>
					</div>

					<div className='card-image'>
						<figure className='image'>
							<img src='/help_screenshots/calendar_3.png' alt='List view button' />
						</figure>
					</div>

					<div className='card-content'>
						<div className='content'>
							<h5>TIPS</h5>
							<ul>
								<li>
									Click a schedule item on the Calendar to open the expanded event view of the workshop.
								</li>
								<li>
									Click outside of the expanded popup to go back to the calendar view.
								</li>
							</ul>
						</div>
					</div>

				</div>
			</div>



		</div>
	)
}

export default HelpPageSample